import { useContent } from "../context/ContentContext";

export default function Marquee() {
  const content = useContent();
  const items = content.marquee || [];
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-brand/25 bg-brand-light py-3.5"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-mono flex items-center text-xs uppercase tracking-[0.3em] text-brand-dark"
              >
                <span className="px-6">{item}</span>
                <span className="text-brand">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
